import { ConfiguratorFillingSelectionRejectedError } from '../../../stores/configurator-mutation-sync';

/** A dialog without a new selection confirms its current value; only X clears it. */
export function getConfirmedConfiguratorSelection(
  value: string,
  selection: { kod: string } | null,
): string {
  return selection?.kod ?? value;
}

const saveErrorLabels = {
  cs: 'Výběr se nepodařilo potvrdit. Zkuste to znovu.',
  sk: 'Výber sa nepodarilo potvrdiť. Skúste to znova.',
  en: 'The selection could not be confirmed. Please try again.',
} as const;

const fillingRejectedLabels = {
  cs: 'Server výběr výplně nepotvrdil. Zkontrolujte provedení a zkuste jinou výplň.',
  sk: 'Server výber výplne nepotvrdil. Skontrolujte vyhotovenie a skúste inú výplň.',
  en: 'The server did not confirm the filling selection. Check the door variant and try another filling.',
} as const;

export function getConfiguratorSelectionSaveError(locale: string, error?: unknown): string {
  const labels =
    error instanceof ConfiguratorFillingSelectionRejectedError
      ? fillingRejectedLabels
      : saveErrorLabels;
  return labels[locale as keyof typeof labels] ?? labels.en;
}
